var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8877_127815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8033 34.6975L35 52.5008L26.25 54.2508L28 45.5008L45.8033 27.6975C46.2615 27.2386 46.8056 26.8746 47.4046 26.6262C48.0035 26.3778 48.6456 26.25 49.294 26.25C49.9424 26.25 50.5845 26.3778 51.1834 26.6262C51.7824 26.8746 52.3265 27.2386 52.7847 27.6975L52.8033 27.7162C53.2622 28.1743 53.6262 28.7184 53.8746 29.3174C54.123 29.9163 54.2508 30.5584 54.2508 31.2068C54.2508 31.8552 54.123 32.4973 53.8746 33.0963C53.6262 33.6952 53.2622 34.2394 52.8033 34.6975Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.75H33.25",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 26.25H33.25",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 36.75H21",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 47.25H5.25C4.32174 47.25 3.4315 46.8812 2.77513 46.2249C2.11875 45.5685 1.75 44.6783 1.75 43.75V5.25C1.75 4.32174 2.11875 3.4315 2.77513 2.77513C3.4315 2.11875 4.32174 1.75 5.25 1.75H30.051C30.9786 1.7502 31.8682 2.11862 32.5243 2.77433L39.2257 9.47567C39.8814 10.1318 40.2498 11.0214 40.25 11.949V19.25",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8877_127815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.96616fbe.svg";
export { ForwardRef as ReactComponent };